import type { DocumentResponse } from '../types';

// O bucket recebe `{prefix}/{collection_id}/{uuid4()}_{nome-original}` — o uuid
// evita colisão entre uploads de mesmo nome, mas não é pra aparecer na tela.
const UUID_PREFIX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_/i;

/** Último segmento da URI, sem o prefixo uuid de deduplicação. */
export function fileNameFromUri(uri: string): string {
  const lastSegment = uri.split('/').pop() ?? uri;
  const decoded = safeDecode(lastSegment);
  return decoded.replace(UUID_PREFIX, '');
}

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    // Nome com '%' literal quebra o decode; melhor mostrar cru que estourar.
    return value;
  }
}

/**
 * Nome do documento para exibição. Prefere o `filename` que o backend guardou
 * no upload; cai pra URI quando o documento foi ingerido por URI e nunca teve
 * um "nome enviado".
 */
export function documentDisplayName(
  document: Pick<DocumentResponse, 'source_uri' | 'filename'>,
): string {
  const stored = document.filename?.trim();
  if (stored) return stored;
  return fileNameFromUri(document.source_uri);
}

/**
 * Encurta pelo meio, preservando a extensão — `relatorio-anual-2024.pdf` diz
 * mais que `relatorio-anual-t…`. Só usar onde não há espaço; a tabela já trunca
 * por CSS com o nome inteiro disponível no title.
 */
export function truncateMiddle(name: string, maxLength = 40): string {
  if (name.length <= maxLength) return name;
  const dot = name.lastIndexOf('.');
  const ext = dot > 0 && name.length - dot <= 8 ? name.slice(dot) : '';
  const stem = ext ? name.slice(0, dot) : name;
  const keep = maxLength - ext.length - 1;
  if (keep <= 0) return name.slice(0, maxLength);
  return `${stem.slice(0, keep)}…${ext}`;
}
